const CHAPA_NET_MULTIPLIER = 0.97125;
const CAREGIVER_SPLIT = 0.8;

export const caregiverNetAmount = (grossAmount) => {
  const amount = Number(grossAmount);
  if (!Number.isFinite(amount)) return 0;

  const chapaFee = Number((amount * (1 - CHAPA_NET_MULTIPLIER)).toFixed(2));
  const netAfterChapaFee = Number((amount - chapaFee).toFixed(2));

  return Number((netAfterChapaFee * CAREGIVER_SPLIT).toFixed(2));
};
